import React, { ReactElement } from 'react';
import Button from '../../../components/button/button.component';
import TextHeader from '../../../components/text-header/text-header.component';
import LineBreak from '../../../components/line-break/line-break.component';
import FlexContainer from '../../../components/flex-container/flex-container.component';
import ErrorFallbackContainer from '../../../components/error-fallback-container/error-fallback-container.component';
import MainService from '../../../services/main-service';
import { NODE_ENV_DEVELOPMENT } from '../../../constants/system/node-envs';

const ErrorFallback: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isFullWidth,
    error,
    onTryAgainClick,
  } = props;

  const isDevelopmentEnvironment: boolean = MainService.NODE_ENV === NODE_ENV_DEVELOPMENT;

  return (
    <ErrorFallbackContainer isFullWidth={isFullWidth}>
      <TextHeader isSubHeader>
        Something went wrong
      </TextHeader>
      {
        isDevelopmentEnvironment && error ? (
          <FlexContainer isColumn isFlexStart>
            {error.message}
            .
            <LineBreak />
            {error.stack}
            .
            <LineBreak />
            <Button isText isDefault onClick={onTryAgainClick}>
              Try again
            </Button>
          </FlexContainer>
        ) : (
          <FlexContainer isColumn isFlexStart>
            Please, contact your system administrator.
          </FlexContainer>
        )
      }
    </ErrorFallbackContainer>
  );
});

export default ErrorFallback;
